import _ from 'lodash';

const state = {
  bySite: {},
  namedUnits: {},
  nonceBySite: {},
  lastCheck: 0, // Used to prevent flooding of the API.
};

const actions = {
  // StoreNamedUnitsCacheForReservable commits a list of named units
  // from fetcher.
  StoreNamedUnitsCacheForReservable({ commit }, payload) {
    commit('STORE_NAMED_UNITS_CACHE_FOR_RESERVABLE', payload);
  },

  ClearNamedUnitsCacheForSite({ commit }, payload) {
    commit('CLEAR_NAMED_UNITS_CACHE_FOR_SITE', payload);
  },

  // StoreReservablesCacheForSite commits a list of reservables from fetcher.
  StoreReservablesCacheForSite({ commit }, payload) {
    commit('STORE_RESERVABLES_CACHE_FOR_SITE', payload);
  },

  // StoreReservablesCacheNoneForSite commits a new nonce from fetcher.
  StoreReservablesCacheNonceForSite({ commit }, payload) {
    commit('STORE_RESERVABLES_CACHE_NONCE_FOR_SITE', payload);
  },

  // StoreReservablesCacheNoneForSite commits a new nonce from fetcher.
  StoreReservablesCacheNonceLastCheck({ commit }, payload) {
    commit('STORE_RESERVABLES_CACHE_NONCE_LAST_CHECK', payload);
  },
};

const mutations = {
  STORE_NAMED_UNITS_CACHE_FOR_RESERVABLE(stateArg, payload) {
    const stateCopy = stateArg;
    if (!stateCopy.namedUnits[payload.siteId]) {
      stateCopy.namedUnits[payload.siteId] = {};
    }
    stateCopy.namedUnits[payload.siteId][payload.reservableId]
      = payload.namedUnits;
  },

  CLEAR_NAMED_UNITS_CACHE_FOR_SITE(stateArg, payload) {
    const stateCopy = stateArg;
    stateCopy.namedUnits[payload.siteId] = {};
  },

  STORE_RESERVABLES_CACHE_FOR_SITE(stateArg, payload) {
    const stateCopy = stateArg;
    stateCopy.bySite[payload.siteId] = payload.reservables;
  },

  STORE_RESERVABLES_CACHE_NONCE_FOR_SITE(stateArg, payload) {
    const stateCopy = stateArg;
    stateCopy.nonceBySite[payload.siteId] = payload.nonce;
  },

  STORE_RESERVABLES_CACHE_NONCE_LAST_CHECK(stateArg, payload) {
    const stateCopy = stateArg;
    stateCopy.lastCheck = payload;
  },
};

export default { actions, mutations, state };
